export const NotificationMessages = {
  INVALID_UPLOAD: 'Please select valid file.',
  DUPLICATE_UPLOAD: 'Duplicate file',
  MAX_FILE: 'Maximum 2 files can be uploaded',
};
